export default "__VITE_ASSET__CzXA6QSc__"